// az-motion.js — Tercio de las Torres scroll animations
(function () {
  'use strict';

  var EASE = 'cubic-bezier(.22,.61,.36,1)';

  function setup(el, translateFrom, delay) {
    el.style.opacity = '0';
    el.style.transform = translateFrom;
    el.style.transition =
      'opacity 720ms ' + EASE + ' ' + delay + 'ms,' +
      'transform 720ms ' + EASE + ' ' + delay + 'ms';
    el.style.willChange = 'opacity, transform';
  }

  function reveal(el) {
    el.style.opacity = '1';
    el.style.transform = 'none';
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        reveal(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -48px 0px' });

  function watch(el, from, delay) {
    if (!el) return;
    setup(el, from, delay);
    observer.observe(el);
  }

  function watchAll(selector, from, baseDelay, stagger) {
    document.querySelectorAll(selector).forEach(function (el, i) {
      watch(el, from, baseDelay + i * (stagger || 0));
    });
  }

  // ── Trust bar ──────────────────────────────────────────────────────────────
  watchAll('.az-trust__item', 'translateY(24px)', 0, 90);

  // ── Feature aceite ─────────────────────────────────────────────────────────
  watch(document.querySelector('.az-feat__img-wrap'), 'translateX(-36px) scale(.98)', 0);
  watch(document.querySelector('.az-feat__eyebrow'),  'translateY(18px)', 80);
  watch(document.querySelector('.az-feat__heading'),  'translateY(24px)', 160);
  document.querySelectorAll('.az-feat__body').forEach(function (el, i) {
    watch(el, 'translateY(18px)', 240 + i * 80);
  });
  watch(document.querySelector('.az-feat__link'), 'translateY(14px)', 360);

  // ── Familia ────────────────────────────────────────────────────────────────
  watch(document.querySelector('.az-familia__eyebrow'), 'translateY(18px)', 0);
  watch(document.querySelector('.az-familia__heading'), 'translateY(28px)', 100);
  watch(document.querySelector('.az-familia__body'),    'translateY(18px)', 200);
  watch(document.querySelector('.az-familia__link'),    'translateY(14px)', 300);

  // ── Product cards ──────────────────────────────────────────────────────────
  watchAll('.card-wrapper', 'translateY(32px)', 0, 80);

  // ── Chefs ──────────────────────────────────────────────────────────────────
  watch(document.querySelector('.az-chefs__eyebrow'), 'translateY(18px)', 0);
  watch(document.querySelector('.az-chefs__heading'), 'translateY(28px)', 100);
  watchAll('.az-chef-card', 'translateY(28px) scale(.98)', 160, 70);

  // ── Reviews ────────────────────────────────────────────────────────────────
  watch(document.querySelector('.az-reviews__heading'), 'translateY(24px)', 0);

  // ── FAQ ────────────────────────────────────────────────────────────────────
  watch(document.querySelector('.az-faq__heading'), 'translateY(24px)', 0);
  watchAll('.az-faq__item', 'translateY(18px)', 80, 60);

  // ── Newsletter ─────────────────────────────────────────────────────────────
  watch(document.querySelector('.az-newsletter__eyebrow'), 'translateY(18px)', 0);
  watch(document.querySelector('.az-newsletter__heading'), 'translateY(28px)', 100);
  watch(document.querySelector('.az-newsletter__body'),    'translateY(18px)', 200);
  watch(document.querySelector('.az-newsletter__form'),    'translateY(20px)', 300);

  // ── Photo strip ────────────────────────────────────────────────────────────
  watchAll('.az-photo-strip__item', 'scale(0.96)', 0, 60);

})();
